import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useFormatVariantJson } from '@hooks';
import { useStore } from '@stores';

export const ModuleTitle = observer(() => {
  const {
    formStore,
    formStore: { getShowBackBtn },
    featureFlagStore: {
      featureFlags: { enableBackButton },
    },
  } = useStore();
  const { getFormattedText } = useFormatVariantJson();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      {getShowBackBtn && enableBackButton && (
        <Button
          variant="outlined"
          sx={{
            minWidth: 'unset',
            width: '32px',
            height: '36px',
            p: 0.5,
          }}
          data-cy="back-button"
          onClick={() => formStore.prev()}
        >
          <ChevronLeftIcon
            sx={{
              color: 'primary.main',
            }}
          />
        </Button>
      )}

      <Typography
        variant="h1"
        sx={{
          color: 'custom.headerText',
          flex: 1,
          fontSize: '18px',
        }}
      >
        {getFormattedText('title')}
      </Typography>
    </Box>
  );
});
